// Libs
import classNames from 'classnames/bind';
import { useTranslation } from 'react-i18next';
import { Avatar, Badge, Box, ListItemAvatar } from '@mui/material';
// Components, Layouts, Pages
// Others
import { IMemberMessage } from '~/utils/interface/conversation';
import { getAvatarName, getFullName } from '~/utils/helper/common';
import { varColor } from '~/themes/themeVariables';
// Styles, images, icons
import styles from './ConversationUserInfo.module.scss';

type Props = {
  data?: IMemberMessage;
  children?: React.ReactNode;
};

const cx = classNames.bind(styles);

const ConversationUserInfo = (props: Props) => {
  //#region Destructuring Props
  const { data, children } = props;
  //#endregion Destructuring Props

  //#region Declare Hook
  const { t } = useTranslation(['admin/conversation']);
  //#endregion Declare Hook

  //#region Selector
  //#endregion Selector

  //#region Declare State
  //#endregion Declare State

  //#region Declare Memo
  //#endregion Declare Memo

  //#region Implement Hook
  //#endregion Implement Hook

  //#region Handle Function
  //#endregion Handle Function

  return (
    <Box id='conversationUserInfoComponent' className={cx('conversationContainer')}>
      <Box className={cx('conversationUser')}>
        <ListItemAvatar className={cx('listItemAvatar')}>
          <Badge
            overlap='circular'
            color='default'
            variant='dot'
            sx={{
              '& .MuiBadge-badge': {
                backgroundColor: data?.isOnline ? varColor.statusOnline : varColor.statusOffline,
              },
            }}
            anchorOrigin={{ horizontal: 'right', vertical: 'bottom' }}
            slotProps={{
              badge: {
                className: cx('badge'),
              },
            }}
          >
            {data?.avatarImage ? (
              <Avatar
                alt={t('common_alt_img', { ns: 'common/base' })}
                src={data?.avatarImage}
                className={cx('avatar')}
              />
            ) : (
              <Avatar alt={t('common_alt_img', { ns: 'common/base' })} className={cx('avatar')}>
                {getAvatarName(getFullName({ ...data }))}
              </Avatar>
            )}
          </Badge>
        </ListItemAvatar>

        <Box className={cx('conversationUserContent')}>
          <Box component={'p'} className={cx('conversationUserName')}>
            {getFullName({ firstName: data?.firstName, lastName: data?.lastName })}
          </Box>

          <Box component={'p'} className={cx('conversationStatus')}>
            {data?.isOnline ? t('status_active_label') : t('status_inactive_label')}
          </Box>
        </Box>
      </Box>

      <Box>{children}</Box>
    </Box>
  );
};

export default ConversationUserInfo;
